import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";
import {isEqual} from "lodash";
import {ProfileEditFormBaseState} from "features/forms/profile-edit";

const baseState = state => state.user.profile;

export const profileData = createSelector([baseState], (state) => {
    return state.data;
});
export const profileSpecialRequestCount = createSelector([baseState], (state) => {
    return state.data.special_request_remaining;
});
export const profileQrCode = createSelector([baseState], (state) => {
    return state.qr;
});

export const profileGetLoading = createSelector([baseState], (state) => {
    return state.get.status === ReducerStatuses.LOADING && isEqual(ProfileEditFormBaseState, state.data);
});

export const profileSaveLoading = createSelector([baseState], (state) => {
    return state.save.status === ReducerStatuses.LOADING;
});
export const profileSaveError = createSelector([baseState], (state) => {
    return {
        inError: state.save.status === ReducerStatuses.ERROR,
        error: state.save.error
    };
});